import type { CSSProperties } from 'react';
import styles from './objects.module.css';

const RAYS = [
  [0, -1],
  [0.8, -0.7],
  [1, 0],
  [0.8, 0.7],
  [0, 1],
  [-0.8, 0.7],
  [-1, 0],
  [-0.8, -0.7],
] as const;

/**
 * A burst of sparks at (x, y) in the SVG it sits in. It plays once when it is mounted and is
 * gone (invisible) afterwards: mount it when the thing happens, with a key that changes each time.
 */
export function Burst({
  x,
  y,
  color = 'var(--c-neon-amber)',
  reach = 16,
}: {
  x: number;
  y: number;
  color?: string;
  reach?: number;
}) {
  return (
    <g transform={`translate(${x} ${y})`} aria-hidden="true">
      {RAYS.map(([dx, dy], i) => (
        <line
          key={i}
          className={styles['spark']}
          x1={dx * 3}
          y1={dy * 3}
          x2={dx * 7}
          y2={dy * 7}
          stroke={color}
          strokeWidth={2}
          style={{ '--dx': `${dx * reach}px`, '--dy': `${dy * reach}px` } as CSSProperties}
        />
      ))}
    </g>
  );
}
